/** @format */

import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import Loader from "../../elements/Loader";
import Pagination from "../../elements/Pagination";
import { debounce } from 'lodash';

export default function Users() {
  console.log('Userlist')
  const [user,setUser]=useState([]);
  const [pageCount,setPageCount]=useState(0);
  const [currentPage,setCurrentPage]=useState(0);
  const [loading,setLoading]=useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleCounts, setRoleCounts] = useState({});
  const [selectedRole, setSelectedRole] = useState('');

  const getRoleCounts = useCallback(async () => {
    ApiService.get('user/count-by-role').then((data) => {
      if (data?.result) {
        setRoleCounts(data.result);
      }
    }).catch((err) => {
      console.log('Failed to fetch role counts', err);
    });
  }, []);

  useEffect(()=>{
    getRoleCounts();
  }, [getRoleCounts]);

  const getUserList = useCallback(async () => {
    setLoading(true)
    ApiService.get(`user?page=${currentPage+1}&limit=20`).then((data)=>{
      setLoading(false)
      if(data?.result?.data){
        setUser(data.result.data);
        setPageCount(data?.result?.totalPages);
      }else{
        setUser([]);
        setPageCount(0);
      }
    }).catch((err)=>{
      //toast.error(err?.response?.data);
      setLoading(false)
    })
  }, [currentPage]);

  const getUsersByRole = useCallback(async (role) => {
    setLoading(true);
    ApiService.get(`user/role/${role}?page=${currentPage+1}&limit=20`).then((data) => {
      setLoading(false);
      if (data?.data) {
        setUser(data.data);
        setPageCount(data.totalPages);
      } else {
        setUser([]);
        setPageCount(0);
      }
    }).catch((err) => {
      setLoading(false);
    });
  }, [currentPage]);

  const handleRoleFilter = (role) => {
    const next = selectedRole === role ? '' : role;
    setSelectedRole(next);
    setCurrentPage(0);
    setSearchTerm('');
  }

  const searchUsers = useCallback(async (term) => {
    setLoading(true);
    try {
      const response = await ApiService.get(`user/search?searchTerm=${term}&page=${currentPage + 1}&limit=20`);
      if (response?.result?.data) {
        setUser(response.result.data);
        setPageCount(response.result.totalPages);
      } else {
        setUser([]);
        setPageCount(0);
      }
    } catch (err) {
      toast.error('Failed to search users');
    } finally {
      setLoading(false);
    }
  }, [currentPage]);

  // Debounced search function
  const debouncedSearch = useMemo(() => debounce((value) => {
    searchUsers(value);
  }, 500), [searchUsers]);

  useEffect(()=>{
    if (searchTerm) {
      debouncedSearch(searchTerm);
    } else if (selectedRole) {
      getUsersByRole(selectedRole);
    } else {
      getUserList();
    }
  }, [currentPage, searchTerm, selectedRole, debouncedSearch, getUserList, getUsersByRole]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSelectedRole('');
    if (!value) {
      getUserList();
    }
  };

  const handlePageClick=(selectedPage)=>{
    const clickedPage = selectedPage.selected;
    if (clickedPage !== currentPage) {
      setCurrentPage(clickedPage);
    }
  }

  return (
    <div className="row">
      <div className="col-xl-12">
      {loading && <Loader/>}
        <div className="card dz-card" id="bootstrap-table2">
          <div className="card-header flex-wrap d-flex justify-content-between  border-0">
            <div>
              <h4 className="card-title">User List</h4>
            </div>
            <div className="d-flex align-items-center">
              <div className="input-group search-area" style={{ width: '300px' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search users..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <span className="input-group-text">
                  <i className="flaticon-381-search-2"></i>
                </span>
              </div>
              <Link to="/add-user" className="btn btn-primary ms-3">
                Add user
              </Link>
            </div>
          </div>
          {/* Role counts / filters */}
          {Object.keys(roleCounts).length > 0 && (
            <div className="px-4 pb-3 d-flex flex-wrap gap-2">
              {Object.entries(roleCounts).map(([role, count]) => (
                <span
                  key={role}
                  onClick={() => handleRoleFilter(role)}
                  className={`badge light ${selectedRole === role ? 'badge-dark' : 'badge-primary'}`}
                  style={{ fontSize: '13px', padding: '6px 12px', cursor: 'pointer' }}
                  title={selectedRole === role ? 'Click to clear filter' : `Filter by ${role}`}
                >
                  {role}: <strong>{count}</strong>
                  {selectedRole === role && <span className="ms-1">×</span>}
                </span>
              ))}
            </div>
          )}

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-responsive-md">
                <thead>
                  <tr>
                    <th>
                      <strong>Sr No.</strong>
                    </th>

                    <th>
                      <strong>Name</strong>
                    </th>

                    <th>
                      <strong>Email</strong>
                    </th>

                    <th>
                      <strong>Phone</strong>
                    </th>

                    <th>
                      <strong>Role</strong>
                    </th>

                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Created At</strong>
                    </th>
                    <th>
                      <strong>Action</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {user && user?.length>0 && user.map((dp,key)=>{
                    const utcDate = new Date(dp.createdAt);
                    const formattedDateTime = utcDate.toLocaleString("en-GB", {
                      timeZone: "Asia/Kolkata", // Automatically converts to IST
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                  }).replace(",", ""); // Format as DD/MM/YYYY HH:MM AM/PM
                    return(
                  <tr key={dp.id}>
                    <td>
                      <strong>{currentPage * 20 + key + 1}</strong>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">

                        <span className="w-space-no">{dp.name}</span>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex align-items-center">

                        <span className="w-space-no">{dp.email}</span>
                      </div>
                    </td>


                    <td>
                      <div className="d-flex align-items-center">

                        <span className="w-space-no">{dp.phone}</span>
                      </div>
                    </td>


                    <td>
                      <div className="d-flex align-items-center">

                        <span className="w-space-no">{dp.role}</span>
                      </div>
                    </td>

                    <td>{dp?.status }</td>
                    <td>{formattedDateTime}</td>
                    <td>
                      <div className="d-flex">
                      <Link
                          to={`/edit-user/${dp?.id}`}
                          className="btn btn-primary shadow btn-xs sharp me-1"
                        >
                          <i className="fa fa-pencil" />
                        </Link>
                        <Link
                          to={`/puja-calendar/${dp?.id}`}
                          className="btn btn-success shadow btn-xs sharp me-1"
                          title="View Puja Calendar"
                        >
                          <i className="fa fa-calendar" />
                        </Link>
                      </div>
                    </td>
                  </tr>)
               }) }
                </tbody>
              </table>

              <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
            </div>
          </div>
        </div>
      </div>
      {/* /tab-content */}
    </div>
  );
}
